/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    SPLIT_COMPANY_PROFILE_SERVICES
 * Date:         2025-12-29
 * Modified By:  Cursor
 *
 * Description:
 * Extracted company services and about sections from CompanyProfileForm.tsx.
 *
 * Related Screens / Modules:
 * - client/src/components/setup/company-profile/components/CompanyServices.tsx
 */
import React from "react";
import { Form, Card } from "react-bootstrap";

export const CompanyServices: React.FC<{ formik: any }> = ({ formik }) => {
  return (
    <>
      <Card className="mb-3 border-0">
        <Card.Body>
          <Card.Title className="company-profile-title">Company Services (optional)</Card.Title>
          <div className="mt-3">
            <Form.Control as="textarea" rows={3} className="field-input" maxLength={300} {...formik.getFieldProps("services")} placeholder="Describe your services" />
            <div className="text-end text-muted small mt-2">{formik.values.services?.length || 0}/300</div>
          </div>
        </Card.Body>
      </Card>
      <Card className="mb-3 border-0">
        <Card.Body>
          <Card.Title className="company-profile-title">About the company (optional)</Card.Title>
          <div className="mt-3">
            <Form.Control as="textarea" rows={5} className="field-input" maxLength={300} {...formik.getFieldProps("aboutCompany")} placeholder="About the company" />
            <div className="text-end text-muted small mt-2">{formik.values.aboutCompany?.length || 0}/300</div>
          </div>
        </Card.Body>
      </Card>
    </>
  );
};
